<template>
  <div class="mask">
      <div class="borderShadow rule" v-show="maskType === 'rule'">
        <img class="btn-close btn" @click="closeModel" src="~/assets/signInModule/btn-close.png" alt="" />
        <img class="bg-title" src="~/assets/signInModule/title-rule.png" alt="">
        <div class="frame">
            <div class="scroll-rule">
              <div v-for="(item) in rule" :key="item.sequence" class="rule-text">
                  {{item.descTextForPM}}
              </div>
            </div>
        </div>
      </div>
      <div class="borderShadow-gray fail" v-show="maskType === 'fail'">
        <img src="~/assets/signInModule/fail-star.png" class="star" />
        <img class="btn-close btn" @click="closeModel" src="~/assets/signInModule/btn-close.png" alt="" />
        <img class="bg-title" src="~/assets/signInModule/title-signIn-fail.png" alt="">
        <div class="frame-gray">
            <div class="fail-tip">游戏需要下载才可以签到哦</div>
            <div class="banner-btn btn" @click="downloadGame" :style="{'background-image':'url('+btnRed+')'}">
              <span>{{btnTxt}}</span>
            </div>
        </div>
      </div>
      <div class="borderShadow success" v-show="maskType === 'shareSuccess' || maskType === 'signInSuccess'">
          <img src="~/assets/signInModule/success-star.png" class="star" />
          <img class="btn btn-close" @click="closeModel" src="~/assets/signInModule/btn-close.png" alt="" />
          <img v-if="maskType === 'signInSuccess'" class="bg-title" src="~/assets/signInModule/title-signIn-success.png" alt="">
          <img v-if="maskType === 'shareSuccess'" class="bg-title" src="~/assets/signInModule/title-signIn-share.png" alt="">
          <div class="frame">
                <div class="award-row" :style="{'background-image':'url('+bgAwardShadow+')'}">
                  <img :src="awardInfo.icon" alt="">
                  <div class="award-name ellipsis">{{awardInfo.awardName}}</div>
                </div>
                <div class="award-conversion" v-if="awardInfo.propType == 20">
                    礼包码：{{awardInfo.giftCodeNum}}
                    <img class="btn btn-copy itemBtn copyName" @click="copyGiftCode(awardInfo.giftCodeNum)" src="~/assets/signInModule/btn-copy.png" alt="">
                </div>
                <div class="award-desc">{{awardInfo.awardDesc}}</div>
                <div @click="downloadGame" class="btn btn-start" :style="{'background-image':'url('+btnStartGame+')'}">
                  <span>开始游戏</span>
                </div>
                <div class="share-panel" v-if="maskType === 'signInSuccess'">
                      <div @click="openShare(0x1)" class="share-row" :style="{'background-image':'url('+bgShareIcon+')'}">
                          <img src="~/assets/signInModule/icon-wechat.png" />
                          <div class="share-row-name">微信</div>
                      </div>
                      <div  @click="openShare(0x2)" class="share-row" :style="{'background-image':'url('+bgShareIcon+')'}">
                          <img src="~/assets/signInModule/icon-circle.png" />
                          <div class="share-row-name">朋友圈</div>
                      </div>
                      <div  @click="openShare(0x3)" class="share-row" :style="{'background-image':'url('+bgShareIcon+')'}">
                          <img src="~/assets/signInModule/icon-qq.png" />
                          <div class="share-row-name">QQ</div>
                      </div>
                      <div  @click="openShare(0x4)" class="share-row" :style="{'background-image':'url('+bgShareIcon+')'}">
                          <img src="~/assets/signInModule/icon-zone.png" />
                          <div class="share-row-name">QQ空间</div>
                      </div>
                </div>
          </div>
      </div>
  </div>
</template>

<script>
import Vue from 'vue';
import btnRed from '@/assets/signInModule/btn-red.png'
import bgAwardShadow from '@/assets/signInModule/bg-award-shadow.png'
import btnStartGame from '@/assets/signInModule/btn-start-game.png'
import bgShareIcon from '@/assets/signInModule/bg-share-icon.png'
import { Toast } from 'vant';
import primaryApi from '@/utils/primaryApi'
import Clipboard from 'clipboard'
Vue.use(Toast);
export default {
  props:['maskType'],
  components: {
    
  },
  data() {
    return {
      btnRed,
      bgAwardShadow,
      btnStartGame,
      bgShareIcon,
      rule:'',
      btnTxt:'下载游戏',
      awardInfo:{}
    }
  },
  methods: {
    openShare(type){
      this.$emit('shareWeb',type)
    },
    closeModel(){
      this.$emit('closeModel')
    },
    // 复制邀请码
    copyGiftCode(code) {
        this.$tea('event_activemodal_copy_reward_code', { 'activityId': this.activityId, 'type_code': this.maskType === 'shareSuccess' ? 'checkin_share' : 'checkin'});//数据埋点
        if (primaryApi.isSource) { // 判断运行环境是否233
            primaryApi.writeClipBoard(code); // 233app内复制邀请码到剪切板
            this.$toast('已复制到剪切板');
        } else {
            let clipboard = new Clipboard('.copyName', {
                text: function () {
                    return code
                }
            });
            clipboard.on('success', e => {
                this.$toast('已复制到剪切板');
                // 释放内存
                clipboard.destroy();
            });
            clipboard.on('error', e => {
                this.$toast('复制失败');
                clipboard.destroy();
            });
        }
    },
    downloadGame(){
      this.$tea("event_new_share_landing_click", {
				locationId: 202,
				relationship: 4,
				relationshipExtra2: this.activityId,
				landingParam: this.activityId
			});
      this.$emit('downloadGame','mask')
    }
  }
}
</script>

<style scoped>
  .mask{
    width:100%;
    height:100%;
    position:fixed;
    top:0;
    left:0;
    background:rgba(0,0,0,0.72);
    z-index:999
  }
  .borderShadow{
      width:2.85rem;
      border-radius:0.08rem;
      border:solid 0.02rem #714327;
      margin:0 auto;
      background:#A4774E;
      padding:0.05rem 0.03rem;
      box-shadow: 0px 0 0px 0px #BB834F, 0px 0px 0px 0px #BB834F,0 0.06rem 1px -2px #BB834F,inset 0px 2px 0px 0px #BB834F;
      margin-top:-2px;
      position:relative
  }
  .frame{
      width: 100%;
      background: #FFFFFF;
      border: 0.02rem solid #5C3025;
      border-radius: 0.08rem;
      box-shadow: inset 0px 3px 0px 0px #BB834F,inset 0px -3px 0px 0px #BB834F,inset 3px 0px 0px 0px #BB834F,inset -3px -1px 0px 0px #BB834F;
  }
  .borderShadow-gray{
      width:2.85rem;
      border-radius:0.08rem;
      border:solid 0.02rem #222121;
      background:#7F7F81;
      padding:0.05rem 0.03rem;
      box-shadow: 0px 0 0px 0px #7F7F81, 0px 0px 0px 0px #7F7F81,0 0.06rem 1px -2px #7F7F81,inset 0px 2px 0px 0px #7F7F81;
      position:absolute;
      top:2rem;
      left:0.45rem
  }
   .frame-gray{
      width: 100%;
      background: #E5E5E6;
      border: 0.02rem solid #242222;
      border-radius: 0.08rem;
      box-shadow: inset 0px 3px 0px 0px #ABABB3,inset 0px -3px 0px 0px #ABABB3,inset 3px 0px 0px 0px #ABABB3,inset -3px -1px 0px 0px #ABABB3;
      height:3rem
  }
  .rule{
    position:absolute;
    left:0.45rem;
    top:1.5rem
  }
  .rule .frame{
    padding:0.48rem 0.08rem 0.11rem 0.18rem;
  }
  .scroll-rule{
      overflow: auto;
      height: 2.82rem;
      width: 100%;
      margin:0 auto;
      color:#774733;
      font-size:0.12rem;
      line-height:0.18rem;
      padding-right:0.16rem
  }
  .scroll-rule::-webkit-scrollbar{
      display: block;
      width:3px;
      height:3px;
  }
  .scroll-rule::-webkit-scrollbar-track{
      background: rgba(83, 43, 41,0.28);
      border-radius:2px;
  }
  .scroll-rule::-webkit-scrollbar-thumb{
      background: #E0C7B0;
      border-radius:3px;
  }
  .scroll-rule::-webkit-scrollbar-thumb:hover{
      background: #E0C7B0;
  }
  .bg-title{
      width:1.67rem;
      height:0.5rem;
      position:absolute;
      top:-0.05rem;
      left:50%;
      transform:translateX(-50%);
  }
  .btn-close{
    width:0.36rem;
    height:0.36rem;
    position:absolute;
    top:-0.12rem;
    right:-0.12rem;
  }
  .fail-tip{
    color:#C14610;
    font-size:0.16rem;
    text-align:center;
    transform:translateY(1.16rem);
    font-weight:600
  }
  .banner-btn{
    position:absolute;
    bottom:0.7rem;
    width:1.29rem;
    height:0.48rem;
    font-size:0.2rem;
    background-position: center center;
    background-repeat: no-repeat;
    background-size:100% 100%;
    color:white;
    font-weight:bold;
    text-align:center;
    line-height:0.43rem;
    -webkit-text-stroke: 1px #583411;
    left:0.75rem;
}
.btn:active{
  transform:scale(0.9)
}
.star{
  width:2.31rem;
  height:1.56rem;
  position:absolute;
  top:-1.56rem;
  left:50%;
  transform:translateX(-50%)
}
.success{
    position:absolute;
    left:0.45rem;
    top:2rem
}
.success .frame{
  padding-top:0.59rem;
  padding-bottom:0.2rem;
}
.award-row{
    width:0.66rem;
    height:0.84rem;
    background-position: center center;
    background-repeat: no-repeat;
    background-size:100% 100%;
    margin:0 auto;
    padding-top:0.09rem
}
.award-row img{
    width:0.48rem;
    height:0.48rem;
    margin: 0 auto;
    display:block;
    border-radius:6px;
}
.award-conversion{
  width:1.92rem;
  font-size:0.13rem;
  margin: 0.1rem 0 0.1rem 0.4rem;
  color:#774733;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  position:relative;
  height:0.26rem;
  line-height:0.26rem;
  padding-right:0.52rem;
}
.btn-copy{
  position:absolute;
  right:0;
  width:0.48rem;
  height:0.26rem;
}
.award-desc{
  color:#774733;
  font-size:0.12rem;
  width:2.14rem;
  margin:0 auto;
  opacity: 0.6;
  line-height:0.16rem;
  margin-bottom:0.2rem
}
.btn-start{
    width:1.29rem;
    height:0.48rem;
    font-size:0.19rem;
    background-position: center center;
    background-repeat: no-repeat;
    background-size:100% 100%;
    color:white;
    font-weight:bold;
    text-align:center;
    line-height:0.43rem;
    -webkit-text-stroke: 1px #583411;
    margin:0 auto 0.2rem auto
}
.share-panel{
    width:100%;
    height:0.72rem;
    display:flex;
    justify-content:space-around;
}
  .share-row{
      width:0.48rem;
      height:0.72rem;
      background-position: top center;
      background-repeat: no-repeat;
      background-size:100% 0.48rem;
  }
  .share-row img{
      width:0.27rem;
      height:0.27rem;
      margin:0.08rem 0 0.19rem 0.11rem;
      display:block
  }
  .share-row-name{
      text-align:center;
      font-size:0.12rem;
      color:#89551E;
      width:0.6rem;
      height:0.22rem;
      line-height:0.2rem;
      background: #EFD5B1;
      border: 1px solid #6B3916;
      border-radius: 6px;
      margin:0 auto;
      font-weight:500;
      transform:scale(0.8) translate(-12.5%,-12.5%);
  }
  .award-name{
      width:0.66rem;
      height:0.19rem;
      line-height:0.19rem;
      font-size:0.12rem;
      color:#89551E;
      text-align:center;
      margin:0.06rem auto 0 auto;
      padding:0 0.04rem;
      transform: scale(0.8);
      font-weight: bold;
  }
</style>
